module.exports = __webpack_public_path__ + "img/moon-3.602ddfeb.svg";